var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"like-item-container footnote neutral4-color",attrs:{"href":_vm.profileLink}},[_c('p',[_c('span',{staticClass:"primary-color"},[_vm._v(_vm._s(_vm.capitalizeWords(_vm.data.name)))]),_vm._v(" \n      "),_c('span',[_vm._v("Liked This on")]),_vm._v(" \n      "),_c('span',[_vm._v(_vm._s(_vm.createdAt))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }